import type { TFunction } from "react-i18next"
import { EmployerOfRecord, ExternalToolTypeEnum } from "@oysterhr/schema"

export const policiesToolsTabFields = (
  t: TFunction<"staff_interface/VendorsPage", string>,
  data?: EmployerOfRecord,
) => [
  {
    label: "visaWorkPermitProcess",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "visaWorkPermitProcessNotes",
        value: data?.details?.visaWorkPermitProcessNotes,
      },
      {
        label: "visaWorkPermitProcessLink",
        value: data?.details?.visaWorkPermitProcessLink,
      },
    ],
  },
  {
    label: "expensesProcess",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "expensesProcessNotes",
        value: data?.details?.expensesProcessNotes,
      },
      {
        label: "expensesProcessLink",
        value: data?.details?.expensesProcessLink,
      },
    ],
  },
  {
    label: "expensesTool",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "expensesToolNotes",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.Expenses,
        )?.description,
      },
      {
        label: "expensesToolLink",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.Expenses,
        )?.url,
      },
    ],
  },
  {
    label: "timesheetTool",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "timesheetToolNotes",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.Timesheet,
        )?.description,
      },
      {
        label: "timesheetToolLink",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.Timesheet,
        )?.url,
      },
    ],
  },
  {
    label: "payrollTool",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "payrollToolNotes",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.Payroll,
        )?.description,
      },
      {
        label: "payrollToolLink",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.Payroll,
        )?.url,
      },
    ],
  },
  {
    label: "timeOffProcess",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "timeOffProcessNotes",
        value: data?.details?.timeOffProcessNotes,
      },
      {
        label: "timeOffProcessLink",
        value: data?.details?.timeOffProcessLink,
      },
    ],
  },
  {
    label: "timeOffTool",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "timeOffToolNotes",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.TimeOff,
        )?.description,
      },
      {
        label: "timeOffToolLink",
        value: data?.externalTools?.collection?.find(
          tool => tool.toolType === ExternalToolTypeEnum.TimeOff,
        )?.url,
      },
    ],
  },
  {
    label: "oysterBenefits",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "oysterBenefitsNotes",
        value: data?.details?.oysterBenefitsNotes,
      },
      {
        label: "oysterBenefitsLink",
        value: data?.details?.oysterBenefitsLink,
      },
    ],
  },
  {
    label: "employmentAgreement",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "employmentAgreementNotes",
        value: data?.details?.employmentAgreementNotes,
      },
      {
        label: "employmentAgreementLink",
        value: data?.details?.employmentAgreementLink,
      },
    ],
  },
  {
    label: "onboardingProcess",
    type: "notesAndLink",
    editModeType: "notesAndLink",
    value: [
      {
        label: "onboardingProcessNotes",
        value: data?.details?.onboardingProcessNotes,
      },
      {
        label: "onboardingProcessLink",
        value: data?.details?.onboardingProcessLink,
      },
    ],
  },
]
